import { cva } from "class-variance-authority";
import React from "react";
import { Tab as AriaTab } from "react-aria-components";

export interface ITabProps {
  tabKey: string;
  tabName: string;
  className?: string;
  friendlyFeatured?: boolean;
}

export function Tab({
  tabKey,
  tabName,
  className,
  friendlyFeatured = false,
}: ITabProps): JSX.Element {
  return (
    <AriaTab
      id={tabKey}
      className={tabClasses({ className, friendlyFeatured })}
    >
      {tabName}
    </AriaTab>
  );
}

const tabClasses = cva("outline-0 outline-none", {
  variants: {
    friendlyFeatured: {
      true: "border-b-2 text-center cursor-pointer data-[selected]:border-brand-primary data-[selected]:text-black data-[selected]:font-bold  data-[disabled]:cursor-not-allowed data-[selected=false]:border-[#B2B2B2] data-[selected=false]:text-[#B2B2B2] w-1/3 pb-2.5",
      false:
        "data-[selected]:border-b-2 border-brand-primary cursor-pointer data-[disabled]:text-brand-body-secondary",
    },
  },
  defaultVariants: {
    friendlyFeatured: false,
  },
});
